
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/deployable/index.md?watch=parent';
    export const toc = [{"id":"基础","depth":2,"title":"基础"},{"id":"嵌套子表格","depth":2,"title":"嵌套子表格"}];
export const frontmatter = {"title":"可展开","toc":"menu","filename":"pages/pages/reference/deployable/index.md","lastUpdated":1773900960000,"description":"这是一个可展开的动态表格"};